export function venmoPay(handle: string | null | undefined): void {
  const clean = (handle || '').replace('@', '').trim();
  if (!clean) return;
  const url = `venmo://users/${clean}`;
  const web = `https://venmo.com/u/${clean}`;
  window.location.href = url;
  setTimeout(() => window.open(web, '_blank'), 600);
}
